import type {
  UsageFeeBillsQueryResponse,
  UsageFeeBillsQueryVariables,
} from '~/modules/pricing/graphql/queries/usageFeeBills.generated';
import { UsageFeeBillsDocument } from '~/modules/pricing/graphql/queries/usageFeeBills.generated';
import { useInfiniteQuery, type UseInfiniteQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils';

const QUERY_KEY = 'usage-fee-bills-infinity';
export const useInfinityUsageFeeBills = <TData = UsageFeeBillsQueryResponse, TError = unknown>(
  variables?: UsageFeeBillsQueryVariables,
  options?: Omit<
    UseInfiniteQueryOptions<UsageFeeBillsQueryResponse, TError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useInfiniteQuery(
    variables === undefined ? [QUERY_KEY] : [QUERY_KEY, variables],
    (args) => {
      return appFetcher<UsageFeeBillsQueryResponse, UsageFeeBillsQueryVariables>(
        UsageFeeBillsDocument,
        {
          ...variables,
          after: args.pageParam,
        },
      )();
    },
    options,
  );
};

useInfinityUsageFeeBills.getKey = (variables?: UsageFeeBillsQueryVariables) =>
  variables === undefined ? [QUERY_KEY] : [QUERY_KEY, variables];
